import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sessionId) { window.location.replace("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.location.replace("/dashboard");
      } catch (e) {
        window.location.replace("/login");
      }
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="flex flex-col items-center gap-3 text-[#525252]">
        <img src="/vv_logo.jpg" alt="Vintage Vantage" className="h-16 w-16 rounded-full object-cover ring-1 ring-[#E5E0D6] animate-pulse" />
        <p className="font-serif-display text-xl">Signing you in…</p>
      </div>
    </div>
  );
}
